import IsTouch from './is-touch';

export default function outOfTheTargetOnTouch($DOM, container, find, classes) {
	let is = IsTouch($DOM, classes);

	$DOM.win.on('resize orientationchange', function() {
		is = IsTouch($DOM, classes);
	});

	$DOM.bodyTag.on('click touchstart', function(event) {
		const $target = $(event.target);

		if(is.Tablet || is.Mobile) {
			if(!$target.parents(container).length){
				$(find).removeClass(classes.Hover);
			}
		}
	});
}